import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { installiereUngespeichertWarnung } from "@/lib/ungespeichertWarnung";

// Schriftgröße aus localStorage anwenden (Ralph 26.05.2026)
try {
  const size = localStorage.getItem("ui_font_size_px");
  if (size) document.documentElement.style.fontSize = `${parseInt(size, 10)}px`;
} catch { /* ignore */ }

installiereUngespeichertWarnung(); // BUT-0038 zentrale Warnung bei ungespeicherten Eingaben

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <App />,
);

// Register PWA Service Worker
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {});
  });
}
